import styled from "styled-components";

export default styled.div`
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--white);
    cursor: pointer;
    ${props => (props.dir === "rtl" ? "margin-right:" : "margin-left:")}1rem;
`;
